var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { logout } from "../Auth/AuthToken";
import envconfig from "../services/envconfig";
export default function TopBar() {
    return (_jsx(React.Fragment, { children: envconfig.USE_LOCAL_TOKEN && (_jsxs("div", __assign({ className: "micro-topbar-container" }, { children: [_jsx("div", { children: _jsx("span", { id: "page-title", className: "navbar-brand" }) }), _jsx("div", __assign({ className: " micro-logout-nav-link", onClick: logout }, { children: "Sign Out" }))] }))) }));
}
